import React, {createContext, useEffect, useRef, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import CorporationData from "../components/tabs/corporation-data.jsx";
import CitizenSos from "../components/tabs/citizen-sos.jsx";
import Cad from "../components/tabs/cad.jsx";
import AlternativeHeaders from "../components/tabs/alternative-headers.jsx";
import corporationService from "../../../../services/web/corporation-service.js";
import projectUtils from "../../../../utils/project-utils.js";

export const CorporationContext = createContext(undefined);

const API_URL = import.meta.env.VITE_API_URL;

const tabs = [
    { key: "corporation", component: <CorporationData/>, label: "Dados da corporação"},
    { key: "citizen_sos", component: <CitizenSos/>, label: "SOS Cidadão"},
    { key: "cad", component: <Cad/>, label: "Central de Atendimento e Despacho (CAD)"},
    { key: "alternative_headers", component: <AlternativeHeaders/>, label: "Cabeçalhos alternativos para impressão"},
];

const initialData = {
    name: "",
    city: "",
    prefix: "",
    address: "",
    number: "",
    neighborhood: "",
    phone: "",
    institutional_email: "",
    time_zone: "",
    latitude: "",
    longitude: "",
    contacts_email: "",
    contacts_phone: "",
    sos_display_name: "",
    sos_email: "",
    alternative_phone: "",
    same_info: "",
    sos_address: "",
    sos_number: "",
    sos_phone: "",
    boName: "",
    fullBoName: "",
    dispatch_help_terms: "",
    templates: [],
    logoEntity: null,
    logoSos: null,
    ecap_name: "",
    ecap_acronym: "",
    maps_api_key: "",
}
const CorporationProvider = ({children}) => {
    const [tabSelected, setTabSelected] = useState("corporation");
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(initialData);
    const [changes, setChangesContext] = useState([])
    const [entity, setEntity] = useState()
    const [contacts, setContacts] = useState()
    const [dispatchHelpEnabled, setDispatchHelpEnabled] = useState()
    const [userIsSentryDev, setUserIsSentryDev] = useState()
    const [dispatchEnabled, setDispatchEnabled] = useState()

    const alternativeHeaderRef = useRef();

    const {data, status: statusInit} = useQuery({
        queryFn: async () => {
            const data = await corporationService.initData()
            const templates = await corporationService.headerTemplates()
            setEntity(data.entity)
            setContacts(data.contacts)
            setDispatchHelpEnabled(data.dispatchHelpEnabled)
            setUserIsSentryDev(data.userIsSentryDev)
            setDispatchEnabled(data.dispatchEnabled)

            const entityNew = projectUtils.normalizeData(data.entity)
            const newContacts = data.contacts?.[0] || {}

            const phone = (entityNew.ddd && entityNew.phone) ? entityNew.ddd + entityNew.phone : ""

            setState(prev => ({
                ...prev,
                name: entityNew.name,
                city: entityNew.city,
                prefix: entityNew.prefix,
                address: entityNew.address,
                number: entityNew.number,
                neighborhood: entityNew.neighborhood,
                phone: phone,
                institutional_email: entityNew.institutional_email,
                time_zone: entityNew.time_zone,
                latitude: entityNew.latitude,
                longitude: entityNew.longitude,
                contacts_email: newContacts?.email,
                contacts_phone: newContacts?.phone,

                sos_display_name: entityNew.sos_display_name,
                alternative_phone: entityNew.alternative_phone,
                same_info: entityNew.same_info,
                sos_address: entityNew.sos_address,
                sos_number: entityNew.sos_number,
                sos_phone: entityNew.sos_phone,
                sos_email: entityNew.sos_email,
                maria_da_penha_label: entityNew.maria_da_penha_label,

                boName: entityNew.boName,
                fullBoName: entityNew.fullBoName,
                dispatch_help_terms: entityNew.dispatch_help_terms,

                sos_image_id: entityNew.sos_image_id,
                maria_da_penha_image: entityNew.maria_da_penha_image,

                ecap_name: entityNew.ecap_name,
                ecap_acronym: entityNew.ecap_acronym,
                templates: templates || [],

                maps_api_key: entityNew.maps_api_key
            }));

            return data
        },
        queryKey: ["initData"],
    })

    useEffect(() => {
        setIsLoading(statusInit === "pending")
    }, [statusInit]);

    const handleInputMask = ({target: {value, id}}) => {
        const clearValue = value.replace(/\D/g, '');
        setState(prev => ({...prev, [id]: clearValue}));
    }

    const setChanges = (target) => setChangesContext(prev => (prev.includes(target) ? prev : [...prev, target]));

    return (
        <CorporationContext.Provider value={{
            entity, contacts, dispatchHelpEnabled, userIsSentryDev, dispatchEnabled,
            tabs,
            tabSelected, setTabSelected,
            isLoading, setIsLoading,
            state, setState,
            changes, setChangesContext,
            alternativeHeaderRef,
            setChanges,
            handleInputMask,

        }}>
            {children}
        </CorporationContext.Provider>
    );
};

export default CorporationProvider;